import { render, staticRenderFns } from "./modern.vue?vue&type=template&id=69a34250&scoped=true"
import script from "./modern.vue?vue&type=script&lang=js"
export * from "./modern.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69a34250",
  null
  
)

export default component.exports